module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admincentro-escolar-cursos-crear/admincentro-escolar-cursos-crear.component.scss
// module id = ./src/app/admincentro-escolar-cursos-crear/admincentro-escolar-cursos-crear.component.scss
// module chunks = main